import { z } from 'zod';
import { dateTimeSchema, uidSchema } from './shared';

export enum PaymentRequestState {
  Pending = 0,
  Paid = 1,
  Cancelled = 2,
  Failed = 3,
}

export const paymentRequestSchema = z.object({
  id: z.string().min(1),
  chat_id: z.string().min(1),
  requester_uid: uidSchema.default(process.env.NEXT_PUBLIC_SUPPORT_ID ?? ''),
  payer_uid: uidSchema,
  amount: z.number().positive(),
  description: z.string().max(500).default(''),
  state: z
    .nativeEnum(PaymentRequestState)
    .default(PaymentRequestState.Pending),
  created_at: dateTimeSchema,
  paid_at: z.number().nullable().default(null),
  charge_id: z.string().nullable().default(null),
  failure_reason: z.string().nullable().default(null),
  order_id: z.string().nullable().default(null),
});

export interface PaymentRequestDocument
  extends z.output<typeof paymentRequestSchema> {}

export const PAYMENT_REQUEST_MSG_PREFIX = 'Payment Request:';
